import { Moment } from 'moment'
import React, { FunctionComponent } from 'react'
import { useForm } from 'react-hook-form'

import {
  IAppointmentCustomer,
  IAppointment,
  IAppointmentFormSubmission,
} from '../../../../types'
// import {
//   AppointmentDateRangePicker,
//   HourPicker,
//   AppointmentActivity,
// } from '../../../Inputs'
import { ICrudActivityDetails } from '../../../types/ICrudActivityDetails'
import { IAddedActivity } from '../../AddActivityViewSwitch/IAddActivity'

import { AppointmentCustomer } from './AppointmentCustomer'
import { UpdateRepetition } from './UpdateRepetition'

interface IProps {
  isSelectViewOpen: boolean
  appointmentMoment?: Moment
  setSelectedActivitiesArray: (activities: ICrudActivityDetails) => void
  selectedActivitiesArray: IAddedActivity[]
  setSelectViewOpen: (viewSwitch: 'activity' | 'menu') => void
  customerDetails: IAppointmentCustomer
  appointment: IAppointment
}

export const UpdateFormFields: FunctionComponent<IProps> = ({
  isSelectViewOpen,
  appointmentMoment,
  setSelectedActivitiesArray,
  selectedActivitiesArray,
  setSelectViewOpen,
  customerDetails,
  appointment,
}) => {
  const { setValue } = useForm<IAppointmentFormSubmission>()

  if (isSelectViewOpen) {
    return null
  }

  return (
    <>
      <AppointmentCustomer customerDetails={customerDetails} />
      {/* <AppointmentDateRangePicker*/}
      {/*  updateAppointment={appointment}*/}
      {/*  setValue={setValue}*/}
      {/*  appointmentMoment={appointmentMoment}*/}
      {/*/ >*/}
      {/* <HourPicker*/}
      {/*  inputName="startHour"*/}
      {/*  appointmentMoment={appointmentMoment}*/}
      {/*  setValue={setValue}*/}
      {/*  updateAppointment={appointment}*/}
      {/*/ >*/}
      {/* <AppointmentActivity*/}
      {/*  setSelectedActivityArray={setSelectedActivitiesArray}*/}
      {/*  selectedActivityArray={selectedActivitiesArray}*/}
      {/*  setSelectViewOpen={setSelectViewOpen}*/}
      {/*/ >*/}
      <UpdateRepetition />
    </>
  )
}
